// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as styles from "./styles.module.scss"
import "../../utils/fontawesome"

export interface SocialProps {
  handle: string
  size?: string
  title?: string
}

const SocialBadge = ({ url, icon, title, size }) => {
  return (
    <a href={url}>
      <FontAwesomeIcon
        className={styles.badge}
        icon={icon}
        size={size}
        title={title}
      />
    </a>
  )
}

export const TwitterBadge: React.FC<SocialProps> = ({
  handle,
  title,
  size,
}) => {
  return (
    <SocialBadge
      url={`https://twitter.com/${handle}`}
      icon={["fab", "twitter"]}
      size={size || "lg"}
      title={title || `Twitter profile for ${handle}`}
    />
  )
}

export const FacebookBadge: React.FC<SocialProps> = ({
  handle,
  title,
  size,
}) => {
  return (
    <SocialBadge
      url={`https://facebook.com/${handle}`}
      icon={["fab", "facebook"]}
      size={size || "lg"}
      title={title || `Facebook profile for ${handle}`}
    />
  )
}

export const GitHubBadge: React.FC<SocialProps> = ({ handle, title, size }) => {
  return (
    <SocialBadge
      url={`https://github.com/${handle}`}
      icon={["fab", "github"]}
      size={size || "lg"}
      title={title || `GitHub profile for ${handle}`}
    />
  )
}

export const LinkedInBadge: React.FC<SocialProps> = ({
  handle,
  title,
  size,
}) => {
  return (
    <SocialBadge
      url={`https://linkedin.com/in/${handle}`}
      icon={["fab", "linkedin"]}
      size={size || "lg"}
      title={title || `LinkedIn profile for ${handle}`}
    />
  )
}

export const CompanyLinkedInBadge: React.FC<SocialProps> = ({
  handle,
  title,
  size,
}) => {
  return (
    <SocialBadge
      url={`https://linkedin.com/company/${handle}`}
      icon={["fab", "linkedin"]}
      size={size || "lg"}
      title={title || `LinkedIn profile for ${handle}`}
    />
  )
}
